import getWizardStep from 'utils/getWizardStep';
import getWizard from './wizardData';

const onSubmitRedirect = (
    result,
    dispatch,
    {
        location,
        navigate,
        ...props
    },
) => {
    const { params: { contractType } } = props;
    const wizard = getWizard(contractType);
    const baseUrl = wizard.prefixTemplate(props.params);
    const nextStep = getWizardStep({ wizard, url: location.pathname });

    navigate(`${baseUrl}/${nextStep}`);
};

export default onSubmitRedirect;
